import React, {FocusEventHandler} from 'react';
import Select from 'react-select';
import {ReactSelectHelper, ReactSelectOnChangeCallback} from './react-select-types';

type getOptionValue<TOption, TValue extends string> = (option: TOption) => TValue;
type getOptionLabel<TOption> = (option: TOption) => string;

type MultiMappingSelectProps<TOption, TValue extends string> = {
  options: readonly TOption[];
  placeholder?: string | null;
  value: TValue[];
  getValue: getOptionValue<TOption, TValue>;
  getLabel: getOptionLabel<TOption>;
  onChange: (value: TValue[]) => void;
  onBlur?: () => void;
};

export class MultiMappingSelect<TOption extends { [index: string]: any }, TValue extends string>
  extends React.Component<MultiMappingSelectProps<TOption, TValue>> {

  constructor(props: Readonly<MultiMappingSelectProps<TOption, TValue>>) {
    super(props);
    this.handleChange = ReactSelectHelper.mappingMulti(
      '',
      props.getValue,
      this.props.onChange
    );
  }

  handleChange: ReactSelectOnChangeCallback<TOption>;

  handleBlur: FocusEventHandler = () => {
    const onBlur = this.props.onBlur;
    if (typeof onBlur === 'function')
      onBlur();
  };

  render() {
    let {options, getValue, getLabel, placeholder} = this.props;
    const value: TOption[] = [];
    for (let item of this.props.value) {
      let found = options.find(x => getValue(x) === item);
      if (found !== undefined)
        value.push(found);
    }

    return (
      <Select<TOption> isMulti={true}
                       options={options}
                       getOptionValue={getValue}
                       getOptionLabel={getLabel}
                       value={value}
                       placeholder={placeholder}                      
                       onChange={this.handleChange}
                       onBlur={this.handleBlur}                       
                       isClearable>
      </Select>);
  }
}
